import React, { memo, useState } from 'react'
import moment from 'moment'
import { IconButton } from 'transfix-ui/components/IconButton'
import { Box } from 'transfix-ui/core'
import { StaplesHeadhaulLane } from 'apps/marketplace/apiTypes/staplesHeadhaulLanes'
import { DeleteIcon, EditIcon, EllipsisIcon } from 'transfix-icons'
import { TableCell, TableRow, OverflowMenu } from 'transfix-ui'
import { FORMATS } from 'constants/datetime'
import { DISPLAY } from 'constants/display'

interface IStaplesHeadhaulLanesRowProps {
  staplesHeadhaulLane: StaplesHeadhaulLane
  onOpenDeleteConfirmation: (id: number) => void
  onOpenEditConfirmation: (id: number, existingData: StaplesHeadhaulLane) => void
}

const { dateFormatShort } = FORMATS

export const StaplesHeadhaulLanesTablesRow = memo<IStaplesHeadhaulLanesRowProps>(
  ({ onOpenDeleteConfirmation, onOpenEditConfirmation, staplesHeadhaulLane }) => {
    const {
      carrierApplication,
      createdAt,
      dailyTrucks,
      deliveryCity,
      deliveryStateCode,
      deliveryWindow,
      id,
      pickupCity,
      pickupStateCode,
      pickupWindow,
      weeklyTrucks,
    } = staplesHeadhaulLane || {}
    const [isExpanded, setIsExpanded] = useState(false)

    const overflowOptions = [
      {
        itemComponent: (
          <Box className='flex flex-row items-center'>
            <EditIcon size='large' />
            <span className='ml2'>Edit</span>
          </Box>
        ),
        label: 'edit',
        action: () => {
          onOpenEditConfirmation(id, staplesHeadhaulLane)
        },
      },
      {
        itemComponent: (
          <Box className='flex flex-row items-center'>
            <DeleteIcon size='large' />
            <span className='ml2'>Delete</span>
          </Box>
        ),
        label: 'delete',
        action: () => {
          onOpenDeleteConfirmation(id)
        },
      },
    ]
    const staplesCityLane = `${pickupCity} \u2192 ${deliveryCity}`
    const transfixBackhaulLane = `${deliveryCity} \u2192 ${pickupCity}`
    return (
      <TableRow highlightOnHover>
        <TableCell>
          {createdAt ? moment(createdAt).format(dateFormatShort) : DISPLAY.empty}
        </TableCell>
        <TableCell>{pickupCity || DISPLAY.empty}</TableCell>
        <TableCell>{pickupStateCode || DISPLAY.empty}</TableCell>
        <TableCell>{deliveryCity || DISPLAY.empty}</TableCell>
        <TableCell>{deliveryStateCode || DISPLAY.empty}</TableCell>
        <TableCell>{staplesCityLane || DISPLAY.empty}</TableCell>
        <TableCell>{transfixBackhaulLane || DISPLAY.empty}</TableCell>
        <TableCell>{carrierApplication?.name || DISPLAY.empty}</TableCell>
        <TableCell>{dailyTrucks || DISPLAY.empty}</TableCell>
        <TableCell>{weeklyTrucks || DISPLAY.empty}</TableCell>
        <TableCell>{pickupWindow || DISPLAY.empty}</TableCell>
        <TableCell>{deliveryWindow || DISPLAY.empty}</TableCell>
        <TableCell>
          <OverflowMenu
            onExpanded={setIsExpanded}
            expanded={isExpanded}
            dropdownId={`${id}-overflow`}
            trigger={
              <IconButton
                Icon={EllipsisIcon}
                label='edit'
                data-test='edit-row'
                onClick={() => setIsExpanded(!isExpanded)}
                size='large'
              />
            }
            options={overflowOptions}
            dataTest='sourced-rate-dropdown'
          />
        </TableCell>
      </TableRow>
    )
  }
)
